import React, { useState }  from 'react';
import { HexColorPicker } from "react-colorful";
import styled from '@emotion/styled';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
  width: 100%;
`;

const Label = styled.label`
  font-size: 0.8rem;
  margin-bottom: 5px;
  text-align: left;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
`;

const ColourPicker = ({ label, colour, setColour, optional = false, ...inputProps }) => {
  return (
    <InputContainer>
      <Label>
        {label}      
        {optional ? <span style={{color:'#727272'}}> (optional)</span> : null}
      </Label>
      <HexColorPicker color={colour} onChange={(colour) => setColour(colour)} {...inputProps} />
    </InputContainer>
  );
};

export default ColourPicker;
